/** @jsxImportSource @emotion/react */

import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { Fragment, ReactElement, useState } from 'react';
import { FeaturedArticleComponentPropTemplate } from '../../../types'

type Props = {
  componentTemplates: FeaturedArticleComponentPropTemplate[]
  insertTextWithCursor: (text: string) => void
}

function ComponentTemplateSelector(props: Props): ReactElement {
  const componentTemplates = props.componentTemplates
  const insertTextWithCursor = props.insertTextWithCursor
  const [selectedComponentTemplate, setSelectedComponetTemplate] = useState(componentTemplates[0])
  const changeSelectedComponentTemplate = (e: SelectChangeEvent) => {
    const selectedComponentTemplateKey = e.target.value
    setSelectedComponetTemplate(
      componentTemplates.find(
        (componentTemplate) => componentTemplate.key === selectedComponentTemplateKey
      )
    )
  }
  const insertSelectedComponentTemplate = () => {
    const text = `${selectedComponentTemplate.template}\n`
    insertTextWithCursor(text)
  }
  return (
    <Fragment>
      <FormControl sx={{ display: 'flex', alignItems: 'center' }}>
        <InputLabel id="component_template_label">テンプレート</InputLabel>
        <Box>
          <Select
            labelId="component_template_label"
            id="component_template"
            label="テンプレート"
            onChange={changeSelectedComponentTemplate}
            sx={{ width: 320 }}
            value={selectedComponentTemplate.key}
          >
            {componentTemplates.map((componentTemplate) => (
              <MenuItem key={componentTemplate.key} value={componentTemplate.key}>
                {componentTemplate.humanName}
              </MenuItem>
            ))}
          </Select>
          <Button variant="outlined" onClick={insertSelectedComponentTemplate} sx={{ ml: 2 }}>
            挿入
          </Button>
        </Box>
      </FormControl>
    </Fragment>
  )
}

export default ComponentTemplateSelector
